import { supabaseClient } from '@/lib/supabaseClient';
import type { Session, User } from '@supabase/supabase-js';

export interface RegistrationResult {
  error: Error | null;
  data: { user: User | null; session: Session | null } | null;
}

export async function registerCustomer(email: string, password: string, firstName: string, lastName: string, referralCode?: string): Promise<RegistrationResult> {
  if (!supabaseClient) return { data: null, error: new Error('Supabase not configured') };
  try {
    const { data, error } = await supabaseClient.auth.signUp({ email, password, options: { data: {
      first_name: firstName.trim(), last_name: lastName.trim(), referral_code: referralCode?.trim().toUpperCase() || null,
    } } });
    if (error) return { data: null, error };
    return { data, error: null };
  } catch (error) {
    return { data: null, error: error instanceof Error ? error : new Error('Registration failed') };
  }
}
